// @flow
import * as React from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import { LinkableCampaign } from '../../domain/CampaignV2Listing';

export const CAMPAIGNS_COUNT_ID = 'linked-external-campaigns-count';
export const CAMPAIGN_DISPLAYED_ID = 'name-of-first-linked-external-campaign';

const Wrapper = styled.div`
  display:flex;
  width: 100%;
`;

const Text = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const CampaignsCount = styled.div`
  font-weight: bold;
  color: ${({ theme }) => theme.V2.colors.primary};
  padding-left: ${({ theme }) => theme.V2.metrics.margin.tiny}px;
  max-width: 30%;
`;

const Tooltip = styled(ReactTooltip)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.V2.metrics.margin.tiny};
`;

const TooltipEntry = styled.div`
  margin-top: ${({ theme }) => theme.V2.metrics.margin.tiny};
`;
type Props = {
  campaign: LinkableCampaign;
}

function getTooltipEntry(name, index) {
  return <TooltipEntry key={`${name}${index}`}>{name}</TooltipEntry>;
}

export default function CampaignV2LinkedTo({ campaign }: Props) {
  const campaignNameToDisplay = campaign.isLinked() ? campaign.getLinkedExternalCampaigns()[0].name : '-';

  const linkedTo = campaign.getLinkedExternalCampaigns();
  const names = linkedTo.map(l => l.name);

  return (
    <Wrapper data-tip={names} data-for={campaign.getReference()}>
      <Text id={CAMPAIGN_DISPLAYED_ID}>
        {campaignNameToDisplay}
      </Text>
      {linkedTo.length > 1 &&
      <CampaignsCount id={CAMPAIGNS_COUNT_ID}>
        {`(+${linkedTo.length - 1})`}
      </CampaignsCount>
      }
      {campaign.isLinked() &&
      <Tooltip id={campaign.getReference()} effect="solid">
        {names.map(getTooltipEntry)}
      </Tooltip>
      }
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/campaigns/components/v2/CampaignV2LinkedTo.js